var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    className: "add-icon",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .add-icon .a, .add-icon .b{\n          fill:#fff;\n      }\n      .add-icon .a{\n          stroke:#707070;\n          opacity:0;\n      }\n      .add-icon .b{\n          stroke:#fff;\n          stroke-width:0.5px;\n      }\n      .add-icon .c{\n          stroke:none;\n      }\n      .add-icon .d{\n          fill:none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(18 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.211 1) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.446,5.806,11.477.775a.454.454,0,1,0-.641-.641L5.8,5.165.774.134A.454.454,0,0,0,.133.775L5.164,5.806.133,10.837a.454.454,0,0,0,.641.641L5.8,6.447l5.031,5.031a.454.454,0,1,0,.641-.641Z",
    transform: "translate(0 -0.001)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.9bd0f9cbd0591e8b0e046d2bb1a3920b.svg";
export { ForwardRef as ReactComponent };